<template src="./MapActionsButton.html"> </template>

<script>

export default {
    name: 'MapActionsButton',
    props: {
        icon: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        color: {
            type: String,
            required: false,
            default: 'primary'
        },
        active: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            
        }
    },
    computed: {

    },
    methods: {

        emitEvent: function() {
            this.$emit('btn-pressed', this.label);
        },
    },
}

</script>

<style lang="scss" src="./MapActionsButton.scss"> </style>